import React from 'react';
import ReactDOM from 'react-dom/client';
import { initSentryLazy } from './sentry';
import './index.css';
// Self-hosted fonts (replaces Google Fonts — no external requests, DSGVO-konform)
import "@fontsource/luckiest-guy";
import "@fontsource/quicksand/400.css";
import "@fontsource/quicksand/600.css";
import "@fontsource/quicksand/700.css";
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";
// HelmetProvider für SEO!
import { HelmetProvider } from "react-helmet-async";
import { ThemeProvider } from "./ThemeContext";

// i18n einbinden (WICHTIG: Reihenfolge egal, aber vor App)
import './i18n';

// Sentry: komplett inaktiv, solange keine REACT_APP_SENTRY_DSN gesetzt ist (No-Op).
// Optionale Vercel-Env-Var — erst eintragen, wenn ein Sentry-Projekt existiert.
// Wird erst nach dem Seitenaufbau nachgeladen (siehe src/sentry.js) – hält ~420 KB
// aus dem Startbundle heraus.
initSentryLazy();

// SEO: statische Canonical-/hreflang-/description-/robots-Tags aus der HTML-Hülle bzw.
// den vorgerenderten Seiten entfernen, bevor Helmet seine eigenen setzt. Helmet verwaltet
// nur Tags mit data-rh und hängt seine Version sonst ZUSÄTZLICH an — das gerenderte DOM
// hatte dadurch zwei Canonicals (auf CSR-Routen widersprüchlich: "/" vs. echte URL).
document.head
  .querySelectorAll('link[rel="canonical"]:not([data-rh]), link[rel="alternate"][hreflang]:not([data-rh]), meta[name="description"]:not([data-rh]), meta[name="robots"]:not([data-rh])')
  .forEach((el) => el.remove());

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <ThemeProvider>
          <App />
        </ThemeProvider>
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);

reportWebVitals();